import React, { useState, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

export default function BasicTimePicker(props) {
  const {
    value,
    onChange,
    label = 'Select Time',
    disabled = false,
    name,
    ...rest
  } = props;

  const [internalValue, setInternalValue] = useState(value ?? null);

  useEffect(() => {
    if (value !== undefined) {
      setInternalValue(value);
    }
  }, [value]);

  const handleChange = (newValue) => {
    setInternalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        value={internalValue}
        onChange={handleChange}
        label={label}
        disabled={disabled}
        name={name}
        {...rest}
      />
    </LocalizationProvider>
  );
}